export enum ApiErrorLevelEnum {
    // TODO : Acceptance
    Info = 'MEDE',
    Warning = 'LETO',
    Error = 'FOUT',
    Choose = 'KIES',
}
